import { Flex, Tag } from 'antd';
import { ClockCircleFilled } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';
import { ModuleType } from 'infrastructure/enums';

import s from './styles.module.scss';

import type { IKeyNoteData } from 'infrastructure/interfaces';

interface IProps {
  note: IKeyNoteData;
  module?: ModuleType;
  isInsideModal?: boolean;
}

export const TemporaryNote = ({ note, module, isInsideModal }: IProps) => {
  if (!note?.expiresAt) return <></>;
  const { expiresAt } = note;
  const { t } = useTranslation();
  const noteDate = new Date(expiresAt);
  const formattedDate = format(noteDate, 'MM/dd/yy');

  return (
    <div className={s['temporary-note-header']}>
      <Flex align="center" gap={8} justify="space-between">
        {module && (
          <Tag
            color={module === ModuleType.RPM ? 'orange' : 'blue'}
            className={s['module-tag']}
          >
            {module.toUpperCase()}
          </Tag>
        )}
        <Flex
          align="center"
          gap={12}
          className={`${s['temporary-note-indicator']} ${
            isInsideModal ? s['no-margin'] : ''
          }`}
        >
          <Flex gap={4}>
            <ClockCircleFilled className={s['temporary-note-clock-icon']} />
            <span className={s['temporary-note-label']}>
              {t('labels.temporaryNote')}
            </span>
          </Flex>
          <div className={s['temporary-note-separator']} />
          <span className={s['temporary-note-expired-date']}>
            {t('labels.expirationDate')} {formattedDate}
          </span>
        </Flex>
      </Flex>
    </div>
  );
};
